import { useEffect } from 'react';
import { applyHead, captureHead, type HeadMeta } from '@/lib/head';

/**
 * Writes the document head for the current route. Renders nothing.
 * The meta object is compared by value so re-renders do not thrash the DOM.
 *
 * During a prerender there is no document and no effect, so the same object is
 * reported to the head sink `src/entry-server.tsx` installed. In the browser
 * `captureHead` is a null check.
 */
import { marketMeta } from '@/lib/markets';
import { useMarket } from '@/lib/market-context';

export default function Head({ meta: inputMeta }: { meta: HeadMeta }) {
  const meta = marketMeta(inputMeta, useMarket().germany);
  const key = JSON.stringify(meta);
  captureHead(meta);
  useEffect(() => {
    applyHead(JSON.parse(key) as HeadMeta);
  }, [key]);
  return null;
}
